import { render, staticRenderFns } from "./OrganizationTree.vue?vue&type=template&id=444d782c&scoped=true"
import script from "./OrganizationTree.vue?vue&type=script&lang=js"
export * from "./OrganizationTree.vue?vue&type=script&lang=js"
import style0 from "./OrganizationTree.vue?vue&type=style&index=0&id=444d782c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444d782c",
  null
  
)

export default component.exports